import React from 'react'
import styled from 'styled-components'

const Body = styled.tbody``

export function TableBody({children}: {children: React.ReactNode}) {
  return <Body>{children}</Body>
}
